export default __webpack_public_path__ + "static/work-tmnt-b8863b0ed62ace7a7fbd236d65018789.jpg";